import { IClientContactViewModel } from '@/shared/types/swagger'

export default function getName(contact: IClientContactViewModel): string {
  return contact.preferredName || `${contact.firstName?.trim?.() ?? ''} ${contact.lastName?.trim?.() ?? ''}`
}